export default {
  gaId: process.env.VUE_APP_GA_ID || '',
  posthogKey: process.env.VUE_APP_POSTHOG_KEY || '',
  posthogHost: process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com'
}
